import React, { memo } from 'react';
import { useTranslation } from '@blocs.i18n';
import DropdownWithChildren, {
  DropdownTogglerTypeEnum,
  SelectionsResultTypeEnum,
} from '@minecraft.dropdown-with-children';

const AdditionalSelect = ({ name, options, handleChange }) => {
  const { t } = useTranslation();

  return (
    <DropdownWithChildren
      isCollapsable={false}
      withFormik
      withSearch
      withSelectionsResult
      selectionsLimit={2}
      placeholder={t('common:form.placeholder.select')}
      selectionsResultType={SelectionsResultTypeEnum.pill}
      dropdownTogglerType={DropdownTogglerTypeEnum.input}
      name={name}
      options={options}
      onOptionsChange={handleChange}
    />
  );
};

export default memo(AdditionalSelect);
